import React from 'react';

import { ShowSVG, HideSVG } from '@newsela/angelou';
import PropTypes from 'prop-types';

import Icon from '@client/common/components/Icon';
import { useRestQuery } from '@client/common/hooks';
import { isLocalEnv } from '@client/utils/environment';

import { $crossWalksCounter, $crosswalksToggle, $showIcon } from './style';

const MONOLITH_BASE_URL = isLocalEnv(window.location.hostname)
  ? 'https://app.dev.newseladev.com'
  : process.env.MONOLITH_BASE_URL;

const useGetTotalCrosswalks = (standardId, crosswalks) => {
  /*
    Temporary workaround to retrieve the total number of crosswalks when standards come from
    search filtering, since those results don’t include the crosswalks field.
    This call will be removed once the crosswalks field is added to the OpenSearch index.
  */

  const endpointPath = `/api/v3/content/delivery/metadata/standard/${standardId}/crosswalk/`;
  const params = new URLSearchParams({ page: 1, page_size: 1 });
  const LANGSTON_CROSSWALKS_ENDPOINT = `${MONOLITH_BASE_URL}${endpointPath}?${params}`;
  const shouldFetch = crosswalks === undefined;
  const { data: crosswalksData } = useRestQuery(shouldFetch ? LANGSTON_CROSSWALKS_ENDPOINT : null);

  if (crosswalks?.length > 0) return crosswalks.length;
  if (crosswalksData?.total > 0) return crosswalksData?.total;

  return 0;
};

const CrosswalksToggle = ({
  standardId,
  crosswalks,
  showCrosswalks,
  setShowCrosswalks
}) => {
  const totalCrosswalks = useGetTotalCrosswalks(standardId, crosswalks);

  if (totalCrosswalks === 0) return null;

  return (
    <>
      <span css={$crossWalksCounter}>CW[{totalCrosswalks}]</span>
      <div css={$crosswalksToggle} onClick={() => setShowCrosswalks((current) => !current)}>
        <Icon icon={showCrosswalks ? HideSVG : ShowSVG} customCss={$showIcon} />{showCrosswalks ? 'Hide' : 'Show'} crosswalks
      </div>
    </>
  );
};

CrosswalksToggle.propTypes = {
  standardId: PropTypes.string.isRequired,
  crosswalks: PropTypes.array,
  showCrosswalks: PropTypes.bool.isRequired,
  setShowCrosswalks: PropTypes.func.isRequired
};

export default CrosswalksToggle;
